<template>
    <div>
        <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="月度" name="month">
                <div style="text-align: center">
                    <reportMonth :handleSelectInput="handleSelectInput"></reportMonth>
                </div>
            </el-tab-pane>
            <el-tab-pane label="季度" name="quarter">
                <div style="display: flex;justify-content: center;align-items: center">
                    <div>
                        <el-date-picker
                                style="width: 120px"
                                v-model="year"
                                format="yyyy年"
                                value-format="yyyy"
                                type="year"
                                placeholder="选择年">
                        </el-date-picker>
                    </div>
                    <div>
                        <el-select style="width: 120px;margin-left: 20px;" v-model="quarter" placeholder="请选择">
                            <el-option
                                    v-for="item in options"
                                    :key="item.key"
                                    :label="item.value"
                                    :value="item.key">
                            </el-option>
                        </el-select>
                    </div>

                </div>
            </el-tab-pane>
            <div class="topTab">
                <div class="HQ">
                    <div class="spanCss">总部:</div>
                    <div :class="[disableParam.HQ?'disableColor':'']">
                        <ul style="overflow: hidden">
                            <li class="HQ-Li" v-for="(item,index) in HQArr" @click="HQClick(index)" ><a :class="{'isActive':index==isHQ}">{{item.bu岗位号}}</a></li>
                        </ul>
                    </div>
                </div>
                <div class="region" >
                    <div class="spanCss">大区:</div>
                    <div :class="[disableParam.region?'disableColor':'']">
                        <ul style="overflow: hidden">
                            <li class="HQ-Li" v-for="(item,index) in regionArr" @click="regionClick(index)" ><a :class="{'isActive':index==isRegion}">{{item.大区岗位号}}</a></li>
                        </ul>
                    </div>
                </div>
                <div class="area">
                    <div class="spanCss">地区:</div>
                    <div :class="[disableParam.area?'disableColor':'']">
                        <ul style="overflow: hidden">
                            <li class="HQ-Li" v-for="(item,index) in areaArr" @click="areaClick(index)" ><a :class="{'isActive':index==isArea}">{{item.地区岗位号}}</a></li>
                        </ul>
                    </div>
                </div>

                <!--            <div class="deputy">-->
                <!--                <div class="spanCss">代表:</div>-->
                <!--                <div>-->
                <!--                    <ul>-->
                <!--                        <li v-for="(item,index) in deputyArr" @click="deputyClick(index)" ><a href="#" :class="{'isActive':index==isDeputy}">{{item.代表岗位号}}</a></li>-->
                <!--                    </ul>-->
                <!--                </div>-->
                <!--            </div>-->
            </div>
            <div class="btn">
                <el-button size="small" style="background: #4EC880;border:none;color: #fff" @click.stop="searchWeekList">查询</el-button>
                <el-button size="small" style="background: #D0021B;border:none;color: #fff" @click.stop="ResetClick">重置</el-button>
                <el-button size="small" style="float: right;background: #4A90E2;border:none;color: #fff" icon="el-icon-upload2" @click.stop="exportDataClick">
                    导出数据
                </el-button>
                <el-button v-if="role==='admin'" size="small" style="float: right;background: #4A90E2;border:none;color: #fff" icon="el-icon-upload2" @click.stop="exportAllData('staff')">
                    导出代表数据
                </el-button>
                <el-button v-if="role==='admin'" size="small" style="float: right;background: #4A90E2;border:none;color: #fff" icon="el-icon-upload2" @click.stop="exportAllData('area')">
                    导出区域数据
                </el-button>
            </div>
            <div class="tableCss">
                <el-table
                        :data="tableData"
                        border
                        style="width: 100%"
                        max-height="500">
                    <el-table-column
                            fixed
                            align="center"
                            type="index"
                            width="50">
                    </el-table-column>
                    <el-table-column
                            fixed
                            align="center"
                            label="BU名称"
                            min-width="180">
                        <template slot-scope="scope">
                            <p>{{scope.row.bu岗位号}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="大区"
                            prop="大区"
                            min-width="180">
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="辖区信息"
                            min-width="180">
                        <template slot-scope="scope">
                            <p>{{scope.row.territory_name}}</p>
                            <p>{{scope.row.territory_owner}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="辖区机构数"
                            min-width="180">
                        <template slot-scope="scope">
                            <p>{{scope.row.辖区机构数}}</p>
                            <p>人均:{{(parseInt(scope.row.辖区机构数) / parseInt(scope.row.人数)).toFixed(0)}}家</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="签到覆盖机构数"
                            min-width="180">
                        <template slot-scope="scope">
                            <p>{{scope.row.签到覆盖机构数}}</p>
                            <p>人均:{{(parseInt(scope.row.签到覆盖机构数) / parseInt(scope.row.人数)).toFixed(0)}}家</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="签到覆盖率"
                            min-width="180">
                        <template slot-scope="scope">
                            <p>{{((parseInt(scope.row.签到覆盖机构数) / parseInt(scope.row.辖区机构数)) * 100).toFixed(0)}}%</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="目标客户数"
                            min-width="180">
                        <template slot-scope="scope">
                            <p>{{scope.row.目标客户数}}</p>
                            <p>人均:{{(parseInt(scope.row.目标客户数) / parseInt(scope.row.人数)).toFixed(0)}}人</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="拜访覆盖目标客户数"
                            min-width="180">
                        <template slot-scope="scope">
                            <p>{{scope.row.拜访覆盖目标客户数}}</p>
                            <p>人均:{{(parseInt(scope.row.拜访覆盖目标客户数) / parseInt(scope.row.人数)).toFixed(0)}}人</p>
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            label="目标客户覆盖率"
                            min-width="180">
                        <template slot-scope="scope">
                            <p v-if="scope.row.拜访覆盖目标客户数=='0' || scope.row.目标客户数=='0'">0%</p>
                            <p v-else>{{((parseInt(scope.row.拜访覆盖目标客户数) / parseInt(scope.row.目标客户数)) * 100).toFixed(0)}}%</p>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-tabs>
    </div>
</template>

<script>
    import reportMonth from "./reportMonth";
    import moment from 'moment'
    import http from "../../../APIService/http";
    export default {
        name: "PopedomOverview",
        data(){
            return {
                role:this.$store.getters.getUser.role,
                date:"",
                isHQ:0,
                isRegion:0,
                isArea:0,
                isTeam:0,
                isDeputy:0,
                HQArr:[],
                regionArr:[],
                areaArr:[],
                deputyArr:[],
                level:"",
                territory_id:'',
                tableData: [],

                bu_territory_id:"",//总部
                la_territory_id:"",//大区
                ra_territory_id:"",//地区
                options:[
                    {key:'Q1',value:'第一季度'},
                    {key:'Q2',value:'第二季度'},
                    {key:'Q3',value:'第三季度'},
                    {key:'Q4',value:'第四季度'}
                ],
                disableParam:{
                  HQ:false,
                  region:false,
                  area:false,
                },
                activeName:'month',
                quarter:'',
                year:''
            }
        },
        components: {
            reportMonth,
        },
        methods:{
            async exportAllData(type){
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        user_id : user.user_id,
                        tenant_id : user.tenant_id,
                        month:this.GLOBAL.date?moment(this.GLOBAL.date).format("YYYYMM"):moment().format("YYYYMM"),
                        role:type,
                        type:this.activeName,
                        year:this.year,
                        quarter:this.quarter
                    }
                    await http.post('/crm/web/report/tabledata/exportOverviewJurisdictionsList',data).then(res=>{
                        if (res.success){
                            // this.exportData = res.data
                            import('@/vendor/Export2Excel').then(excel => {
                                const tHeader = ['BU名称','大区', '辖区信息', '辖区机构数(人均)', '签到覆盖机构数据(平均)', '签到覆盖率','目标客户数','拜访覆盖目标客户数','目标客户覆盖率']
                                const filterVal = [
                                    'bu岗位号',
                                    '大区',
                                    '辖区信息',
                                    '人均机构数',
                                    '平均覆盖机构数据',
                                    '签到覆盖率',
                                    '目标客户数',
                                    '拜访覆盖目标客户数',
                                    '目标客户覆盖率',
                                ]
                                for(let i=0;i<res.data.length;i++){
                                    let obj = res.data[i]
                                    if(obj.辖区机构数=='0'||obj.人数=='0'){
                                        obj.人均机构数='0家'
                                    }else {
                                        obj.人均机构数 = (parseInt(obj.辖区机构数) / parseInt(obj.人数)).toFixed(0)+'家'
                                    }

                                    if(obj.签到覆盖机构数=='0'||obj.人数=='0'){
                                        obj.平均覆盖机构数据 ='0家'
                                    }else {
                                        obj.平均覆盖机构数据 = (parseInt(obj.签到覆盖机构数) / parseInt(obj.人数)).toFixed(0)+'家'
                                    }

                                    if(obj.签到覆盖机构数=='0'||obj.辖区机构数=='0'){
                                        obj.签到覆盖率='0%'
                                    }else {
                                        obj.签到覆盖率 = ((parseInt(obj.签到覆盖机构数) / parseInt(obj.辖区机构数)) * 100).toFixed(0)+'%'
                                    }

                                    if(obj.拜访覆盖目标客户数=='0'||obj.目标客户数=='0'){
                                        obj.目标客户覆盖率='0%'
                                    }else {
                                        obj.目标客户覆盖率 = ((parseInt(obj.拜访覆盖目标客户数) / parseInt(obj.目标客户数)) * 100).toFixed(0)+'%'
                                    }
                                    obj.辖区信息 = obj.territory_name +' '+ obj.territory_owner
                                }

                                const list = res.data
                                const data = this.formatJson(filterVal, list)
                                let fileName = ''
                                if(type === 'staff'){
                                    fileName = this.activeName==='month'?'代表月度辖区概览':'代表季度辖区概览'
                                }else {
                                    fileName = this.activeName==='month'?'区域月度辖区概览':'区域季度辖区概览'
                                }

                                excel.export_json_to_excel({
                                    header: tHeader,
                                    data,
                                    filename: fileName,
                                    autoWidth: this.autoWidth
                                })
                            })
                            loading.close()
                        }
                    })
                } catch (e) {
                    loading.close()
                }
            },
            handleClick(tab,event){
                // if(this.activeName === 'quarter'){
                //     this.year = moment().format('YYYY')
                //     const month = moment().format('M')
                //     if(month == 1 ||month == 2||month == 3){
                //         this.quarter = 'Q1'
                //     }else if(month == 4 ||month == 5||month == 6){
                //         this.quarter = 'Q2'
                //     }else if(month == 7 ||month == 8||month == 9){
                //         this.quarter = 'Q3'
                //     }else if(month == 10 ||month == 11||month == 12){
                //         this.quarter = 'Q4'
                //     }
                // }
                this.getOverviewJurisdictionsList()
            },
            ResetClick(){
                    this.isHQ=0,
                    this.isRegion=0,
                    this.isArea=0,
                    this.isDeputy=0,
                    this.bu_territory_id="",//总部
                    this.la_territory_id="",//大区
                    this.ra_territory_id=""//地区
                this.getBuList()
                this.getLargeAreaList(this.bu_territory_id)
                this.getRegionAreaList(this.bu_territory_id,this.la_territory_id)

            },
            handleSelectInput(j) {
                 this.date = j;
            },
            //点击总部
            HQClick(index){
                if(this.disableParam.HQ) return
                this.isHQ=index
                this.isRegion=0,
                this.isArea=0
                this.la_territory_id="",
                this.ra_territory_id=""
                this.bu_territory_id = this.HQArr[index].bu区域id //总部id

                this.getLargeAreaList(this.bu_territory_id)
                this.getRegionAreaList(this.bu_territory_id,this.la_territory_id)

                // this.getRepresentativeList(this.ra_territory_id,this.bu_territory_id,this.la_territory_id)

            },
            //点击大区
            regionClick(index){
                if(this.disableParam.region) return
                this.isRegion=index
                this.isArea=0
                this.ra_territory_id=""
                this.la_territory_id = this.regionArr[index].大区区域id //大区id
                this.getRegionAreaList(this.bu_territory_id,this.la_territory_id)

                // this.getRepresentativeList(this.ra_territory_id,this.bu_territory_id,this.la_territory_id)
            },
            //点击区域
            areaClick(index){
                if(this.disableParam.area) return
                this.isArea=index
                this.ra_territory_id = this.areaArr[index].地区区域id
                // this.getRepresentativeList(this.ra_territory_id,this.bu_territory_id,this.la_territory_id)
            },
            //点击代表
            deputyClick(index){
                this.isDeputy=index
            },
            //获取Bu
            async getBuList(){
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        user_id : user.user_id,
                        tenant_id : user.tenant_id,
                        role : user.role,
                        month:this.GLOBAL.date?moment(this.GLOBAL.date).format("YYYYMM"):moment().format("YYYYMM"),

                    }

                    await http.post('/crm/web/report/territory/getBuList',data).then(res=>{
                        if (res.success){
                            let allObj = {
                                bu岗位号:'全部',
                                bu区域id:''
                            }
                            if(res.data && res.data.length>0) {
                                res.data.unshift(allObj)
                                this.HQArr = res.data
                            }
                            loading.close()
                        }
                    })
                } catch (e) {
                    loading.close()
                }
            },
            //获取大区
            async getLargeAreaList(val){
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        user_id : user.user_id,
                        tenant_id : user.tenant_id,
                      role : user.role,
                        month:this.GLOBAL.date?moment(this.GLOBAL.date).format("YYYYMM"):moment().format("YYYYMM"),
                        bu_territory_id:val

                    }
                    await http.post('/crm/web/report/territory/getLargeAreaList',data).then(res=>{
                        if (res.success){
                            let allObj = {
                                大区岗位号:'全部',
                                大区区域id:''
                            }
                            if(res.data && res.data.length>0) {
                                res.data.unshift(allObj)
                                this.regionArr = res.data
                            }
                            loading.close()
                        }
                    })
                } catch (e) {
                    loading.close()
                }
            },
            //获取地区
            async getRegionAreaList(bu_territory_id,la_territory_id){
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        user_id : user.user_id,
                        tenant_id : user.tenant_id,
                      role : user.role,
                        month:this.GLOBAL.date?moment(this.GLOBAL.date).format("YYYYMM"):moment().format("YYYYMM"),
                        bu_territory_id:bu_territory_id,
                        la_territory_id:la_territory_id

                    }
                    await http.post('/crm/web/report/territory/getRegionAreaList',data).then(res=>{
                        if (res.success){
                            let allObj = {
                                地区岗位号:'全部',
                                地区区域id:''
                            }
                            if(res.data && res.data.length>0) {
                                res.data.unshift(allObj)
                                this.areaArr = res.data
                            }
                            loading.close()
                        }
                    })
                } catch (e) {
                    loading.close()
                }
            },
            //获取代表
            async getRepresentativeList(ra_territory_id,bu_territory_id,la_territory_id){
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        user_id : user.user_id,
                        tenant_id : user.tenant_id,
                        month:this.GLOBAL.date?moment(this.GLOBAL.date).format("YYYYMM"):moment().format("YYYYMM"),
                        ra_territory_id:ra_territory_id,
                        bu_territory_id:bu_territory_id,
                        la_territory_id:la_territory_id
                    }
                    await http.post('/crm/web/report/territory/getRepresentativeList',data).then(res=>{
                        if (res.success){
                            let allObj = {
                                代表岗位号:'全部',
                                代表区域id:''
                            }
                            if(res.data && res.data.length>0) {
                                res.data.unshift(allObj)
                                this.deputyArr = res.data
                            }
                            loading.close()
                        }
                    })
                } catch (e) {
                    loading.close()
                }
            },
            //获取级别
            async getTerritoryLevelByUser(){

                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        user_id : user.user_id,
                        tenant_id : user.tenant_id,
                        month:this.GLOBAL.date?moment(this.GLOBAL.date).format("YYYYMM"):moment().format("YYYYMM"),

                    }
                    await http.post('/crm/web/report/territory/getTerritoryLevelByUser',data).then(res=>{
                        if (res.success){
                            this.level = res.data.level
                            this.territory_id = res.data.territory_id
                          if(this.level === 0){
                            this.disableParam = {
                              HQ:false,
                              region:false,
                              area:false,
                            }
                          }else if(this.level === 1){
                            this.disableParam = {
                              HQ:true,
                              region:false,
                              area:false,
                            }
                          }else if(this.level === 2){
                            this.disableParam = {
                              HQ:true,
                              region:true,
                              area:false,
                            }
                          }else if(this.level === 3 || this.level === 4){
                            this.disableParam = {
                              HQ:true,
                              region:true,
                              area:true,
                            }
                          }
                          loading.close()
                        }
                    })
                } catch (e) {
                    loading.close()
                }
            },
            //获取tableData
            async getOverviewJurisdictionsList(){

                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        user_id : user.user_id,
                        tenant_id : user.tenant_id,
                        month:this.GLOBAL.date?moment(this.GLOBAL.date).format("YYYYMM"):moment().format("YYYYMM"),
                        department_id :this.bu_territory_id,
                        regional_id:this.la_territory_id,
                        area_id:this.ra_territory_id,
                        level:this.level,
                        territory_id:this.territory_id,
                        type:this.activeName,
                        year:this.year,
                        quarter:this.quarter
                    }
                    await http.post('/crm/web/report/tabledata/getOverviewJurisdictionsList',data).then(res=>{
                        if (res.success){
                            this.tableData = res.data
                            loading.close()
                        }
                    })
                } catch (e) {
                    loading.close()
                }
            },
            //查询
            searchWeekList(){
                this.getOverviewJurisdictionsList()
            },
            //导出
            exportDataClick(){
                this.exportClick()
            },
            exportClick(){
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    import('@/vendor/Export2Excel').then(excel => {
                        const tHeader = ['BU名称','大区', '辖区信息', '辖区机构数(人均)', '签到覆盖机构数据(平均)', '签到覆盖率','目标客户数','拜访覆盖目标客户数','目标客户覆盖率']
                        const filterVal = [
                            'bu岗位号',
                            '大区',
                            '辖区信息',
                            '人均机构数',
                            '平均覆盖机构数据',
                            '签到覆盖率',
                            '目标客户数',
                            '拜访覆盖目标客户数',
                            '目标客户覆盖率',

                        ]
                        for(let i=0;i<this.tableData.length;i++){
                            let obj = this.tableData[i]
                            if(obj.辖区机构数=='0'||obj.人数=='0'){
                                obj.人均机构数='0家'
                            }else {
                                obj.人均机构数 = (parseInt(obj.辖区机构数) / parseInt(obj.人数)).toFixed(0)+'家'
                            }

                            if(obj.签到覆盖机构数=='0'||obj.人数=='0'){
                                obj.平均覆盖机构数据 ='0家'
                            }else {
                                obj.平均覆盖机构数据 = (parseInt(obj.签到覆盖机构数) / parseInt(obj.人数)).toFixed(0)+'家'
                            }

                            if(obj.签到覆盖机构数=='0'||obj.辖区机构数=='0'){
                                obj.签到覆盖率='0%'
                            }else {
                                obj.签到覆盖率 = ((parseInt(obj.签到覆盖机构数) / parseInt(obj.辖区机构数)) * 100).toFixed(0)+'%'
                            }

                            if(obj.拜访覆盖目标客户数=='0'||obj.目标客户数=='0'){
                                obj.目标客户覆盖率='0%'
                            }else {
                              obj.目标客户覆盖率 = ((parseInt(obj.拜访覆盖目标客户数) / parseInt(obj.目标客户数)) * 100).toFixed(0)+'%'
                            }
                            obj.辖区信息 = obj.territory_name +' '+ obj.territory_owner
                        }

                        const list = this.tableData
                        const data = this.formatJson(filterVal, list)

                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: this.activeName==='month'?'月度辖区概览':'季度辖区概览',
                            autoWidth: this.autoWidth
                        })
                    })
                    loading.close();
                } catch (err) {
                    loading.close();
                    this.error()
                }
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },


        },
        created() {
            this.year = moment().format('YYYY')
            const month = moment().format('M')
            if(month == 1 ||month == 2||month == 3){
                this.quarter = 'Q1'
            }else if(month == 4 ||month == 5||month == 6){
                this.quarter = 'Q2'
            }else if(month == 7 ||month == 8||month == 9){
                this.quarter = 'Q3'
            }else if(month == 10 ||month == 11||month == 12){
                this.quarter = 'Q4'
            }
            this.getBuList()
            this.getLargeAreaList(this.bu_territory_id)
            this.getRegionAreaList(this.bu_territory_id,this.la_territory_id)
            this.getTerritoryLevelByUser().then(this.getOverviewJurisdictionsList)



            // this.getRepresentativeList(this.ra_territory_id,this.bu_territory_id,this.la_territory_id)
        }

    }
</script>

<style scoped>
    .el-tabs--border-card{
        box-shadow:none;
        border:none;
    }
    .btn{
        /*text-align: right*/
    }
    .isActive{
        color: red;
    }
    .topTab{
        margin-top: 20px;
    }
    .HQ,.region,.area,.Team,.deputy{
        overflow: hidden;
    }

    .spanCss{
        display: inline-block;
        width: 50px;
        font-size: 16px;
        color: #D8D8D8;
        margin-bottom: 20px;
        float: left;
    }
    .disableColor ul li a{
      color: #D8D8D8 !important;
      cursor: no-drop !important;
    }
    .HQ-Li a {
      cursor: pointer;
    }
    /*ul{*/
    /*    overflow: hidden;*/
    /*}*/
    .HQ-Li{
        float: left;
        line-height: 15px;
        margin-left: 20px;
        margin-bottom: 20px;
    }
    a{
        text-decoration: none;
        color: black;
        font-size: 14px;
    }
    p{
        margin: 0;
        padding: 0;
    }
    .tableCss{
        margin-top: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/statement/components/PopedomOverview.vue